// CAT Mock 4 — DILR section.
const catMock4Dilr = [
  {
    id: 25,
    type: "mcq",
    setId: "di1",
    statement: `A company sells four products, P1–P4, in four regions. The table shows the price of each product (in ₹ per unit, the same in every region) and the number of units sold (in thousands) in each region last year. Revenue = Price × Units sold. (Note: ₹1 lakh = ₹1,00,000.)`,
    table: {
      columns: ["Product", "Price (₹)", "North", "South", "East", "West"],
      rows: [
        ["P1", "250", "40", "30", "25", "45"],
        ["P2", "400", "20", "35", "30", "15"],
        ["P3", "150", "60", "50", "70", "40"],
        ["P4", "600", "10", "15", "12", "18"]
      ]
    },
    question: "Which region generated the highest total revenue?",
    options: [
      "A. North",
      "B. South",
      "C. East",
      "D. West"
    ],
    answer: "B"
  },
  {
    id: 26,
    type: "tita",
    setId: "di1",
    question: "What was the total revenue (in ₹ lakh) from P2 across all four regions?",
    answer: "400"
  },
  {
    id: 27,
    type: "mcq",
    setId: "di1",
    question: "In how many regions did P3 generate more revenue than P4?",
    options: [
      "A. 1",
      "B. 2",
      "C. 3",
      "D. 4"
    ],
    answer: "B"
  },
  {
    id: 28,
    type: "mcq",
    setId: "di1",
    question: "If the price of P4 were cut by 20% and, as a result, its units sold rose by 30% in every region, how would the total revenue from P4 change?",
    options: [
      "A. It would rise by ₹13.2 lakh.",
      "B. It would fall by ₹13.2 lakh.",
      "C. It would rise by ₹33 lakh.",
      "D. It would remain unchanged."
    ],
    answer: "A"
  },
  {
    id: 29,
    type: "tita",
    setId: "di1",
    question: "What was the combined revenue (in ₹ lakh) from P1 and P3 in the East and West regions together?",
    answer: "340"
  },
  {
    id: 30,
    type: "mcq",
    setId: "di2",
    statement: `Eight people — A, B, C, D, E, F, G and H — sit in two parallel rows of four seats each. The people in Row 1 face south and the people in Row 2 face north, so that each person in Row 1 directly faces one person in Row 2. In each row, the seats run from west to east.
• A sits in Row 1 and faces D.
• B sits in Row 2 but not at either end of the row.
• H sits immediately to the east of A.
• C sits at one end of the row in which H sits.
• G is not in the same row as E.
• G sits in the same row as D, somewhere to the west of D.
• E sits at one end of a row.
• F does not face E.`,
    question: "Who faces H?",
    options: [
      "A. G",
      "B. D",
      "C. B",
      "D. F"
    ],
    answer: "C"
  },
  {
    id: 31,
    type: "mcq",
    setId: "di2",
    question: "Who sits at the west end of Row 2?",
    options: [
      "A. G",
      "B. D",
      "C. F",
      "D. B"
    ],
    answer: "A"
  },
  {
    id: 32,
    type: "tita",
    setId: "di2",
    question: "How many people sit between E and C in their row?",
    answer: "2"
  },
  {
    id: 33,
    type: "mcq",
    setId: "di2",
    question: "Which of the following pairs face each other?",
    options: [
      "A. E and F",
      "B. C and G",
      "C. E and G",
      "D. H and D"
    ],
    answer: "C"
  },
  {
    id: 34,
    type: "mcq",
    setId: "di2",
    question: "Who sits immediately to the west of B?",
    options: [
      "A. G",
      "B. F",
      "C. A",
      "D. D"
    ],
    answer: "D"
  },
  {
    id: 35,
    type: "tita",
    setId: "di2",
    question: "Number the seats of Row 1 from 1 to 4 and the seats of Row 2 from 5 to 8, each from west to east. What is the sum of the seat numbers of A, B and F?",
    answer: "17"
  },
  {
    id: 36,
    type: "tita",
    setId: "di3",
    statement: `A stationery shop sells pens at ₹7 each, notebooks at ₹11 each and files at ₹15 each. Three friends — Ravi, Sita and Tom — each bought at least one pen, at least one notebook and at least one file.
• Ravi spent exactly ₹100 and bought more notebooks than pens.
• Sita spent exactly ₹120 and bought as many pens as Ravi bought files.
• Tom spent exactly ₹130 and bought exactly twice as many notebooks as files.`,
    question: "How many items in total did Tom buy?",
    answer: "14"
  },
  {
    id: 37,
    type: "mcq",
    setId: "di3",
    question: "How many notebooks did the three friends buy altogether?",
    options: [
      "A. 12",
      "B. 13",
      "C. 14",
      "D. 15"
    ],
    answer: "C"
  },
  {
    id: 38,
    type: "tita",
    setId: "di3",
    question: "What was the total amount (in ₹) spent on files by the three friends together?",
    answer: "105"
  },
  {
    id: 39,
    type: "mcq",
    setId: "di3",
    question: "Who bought the most pens?",
    options: [
      "A. Ravi",
      "B. Sita",
      "C. Tom",
      "D. Sita and Tom bought the same number"
    ],
    answer: "C"
  },
  {
    id: 40,
    type: "mcq",
    setId: "di3",
    question: "Suppose Sita had instead spent exactly ₹125, all other conditions remaining the same. How many notebooks would she have bought?",
    options: [
      "A. 2",
      "B. 3",
      "C. 4",
      "D. 6"
    ],
    answer: "A"
  },
  {
    id: 41,
    type: "tita",
    setId: "di4",
    statement: `The table shows the percentage of a family's monthly income spent on each category in 2022, 2023 and 2024. Whatever is not spent is saved. The family's monthly income was ₹80,000 in 2022, ₹90,000 in 2023 and ₹1,00,000 in 2024.`,
    table: {
      columns: ["Category", "2022", "2023", "2024"],
      rows: [
        ["Rent", "25%", "24%", "22%"],
        ["Food", "20%", "20%", "21%"],
        ["Transport", "10%", "12%", "11%"],
        ["Education", "15%", "14%", "16%"],
        ["Others", "12%", "12%", "10%"]
      ]
    },
    question: "What were the family's monthly savings (in ₹) in 2024?",
    answer: "20000"
  },
  {
    id: 42,
    type: "mcq",
    setId: "di4",
    question: "Which category saw the highest percentage increase in the monthly amount spent from 2022 to 2024?",
    options: [
      "A. Food",
      "B. Education",
      "C. Rent",
      "D. Transport"
    ],
    answer: "D"
  },
  {
    id: 43,
    type: "tita",
    setId: "di4",
    question: "What was the total monthly amount (in ₹) spent on Food in 2022, 2023 and 2024 taken together?",
    answer: "55000"
  },
  {
    id: 44,
    type: "mcq",
    setId: "di4",
    question: "In how many spending categories did the monthly amount spent fall from one year to the next at least once?",
    options: [
      "A. 0",
      "B. 1",
      "C. 2",
      "D. 3"
    ],
    answer: "B"
  },
  {
    id: 45,
    type: "mcq",
    setId: "di4",
    question: "In 2025 the family's monthly income rises by 10% over 2024. It spends the same amounts as in 2024 on every category except Education, on which spending rises by 25%. Approximately what percentage of its 2025 income does it save?",
    options: [
      "A. 20.0%",
      "B. 21.8%",
      "C. 25.0%",
      "D. 23.6%"
    ],
    answer: "D"
  },
  {
    id: 46,
    type: "tita",
    setId: "di4",
    question: "By what percentage did the monthly amount spent on Transport in 2023 exceed that in 2022? (Enter the number only.)",
    answer: "35"
  }
];

export default catMock4Dilr;
